<div class="avatar-image">
  {{ user().first_name[0] + user().last_name[0] }}
</div>
